import { ViewConfiguration } from '../../../grid/gridView/types';
import { ColumnDetails } from '../../../grid/types/common';

export interface ResponseGridWebComponentSchema {
  // all the data needed for rendering
  views: Array<ViewConfiguration<Column, ColumnKeys>>;
  allColumns: Array<ColumnDetails<Column, ColumnKeys>>;
  defaultViewProps: ViewConfiguration<Column, ColumnKeys>;
  predefinedFilterKeys: Array<ColumnKeys>;
}

export enum ColumnKeys {
  TYPE = 'groupType',
  ACTION = 'type',
  OBJECT = 'objectName',
  TARGET = 'targetName',
  DETAILS = 'details',
  EXECUTED_ON = 'executedOn',
  EXECUTED_BY = 'username',
  SOURCE = 'source',
  STATUS = 'status',
  USER_INLINE_ACTIONS = 'user_inline_actions',
}

export enum Column {
  TYPE = 0,
  ACTION = 1,
  OBJECT = 2,
  TARGET = 3,
  DETAILS = 4,
  EXECUTED_ON = 5,
  EXECUTED_BY = 6,
  SOURCE = 7,
  STATUS = 8,
  USER_INLINE_ACTIONS = 9,
}

export enum Type {
  CONTAINMENT = 1,
  MITIGATION = 2,
  REMEDIATION = 3,
  HARDENING = 4,
}

//r search Must conform with InlineActionsStatus
export enum Status {
  TO_BE_EXECUTED = 1,
  PENDING = 2,
  IN_EXECUTION = 3,
  EXECUTION_SUCCESS = 4,
  EXECUTION_FAILED = 5,
  DISMISSED = 6,
  EXTERNAL_ACTION_NEEDED = 7,
  DONE_EXTERNALLY = 8,
}

export enum Source {
  RECOMMENDATION = 1,
  GZ_AUTOMATED = 2,
  GRAPH = 3,
}

export enum Action {
  ISOLATE = 1,
  DELETE_EMAIL_O365 = 2,
  DISABLE_USER_O365 = 3,
  DISABLE_USER_AD = 4,
  ENABLE_USER_O365 = 5,
  ENABLE_USER_AD = 6,
  RESET_CREDENTIALS_O365 = 7,
  RESET_CREDENTIALS_AD = 8,
  MANAGE_UNMANAGED = 9,
  BLOCK_FILE_HASH = 10,
  SYSTEM_REPAIR = 11,
  BLOCK_IP = 12,
  RESTORE_ENDPOINT = 13,
  RISKY_USER = 14,
  DEACTIVATE_USER_AWS = 15,
  DELETE_EMAIL_GOOGLE = 16,
  DISABLE_USER_GOOGLE = 17,
  ENABLE_USER_GOOGLE = 18,
  DISABLE_USER_ATLASSIAN = 19,
  RESET_CREDENTIALS_ATLASSIAN = 20,
  RESET_CREDENTIALS_GOOGLE = 21,
}

// The names of the keys don't match their type because the column are named different in the backend
export interface ResponseGridItem {
  _id: string;
  type: Action; // Corresponds to the Action column
  groupType: Type; // Corresponds to the Type column
  objectName: string;
  targetName: string;
  details: string;
  executedOn: string;
  username: string; // Corresponds to the EXECUTED_BY column
  source: Source;
  status: Status;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<ResponseGridItem>; // RawEvents is how gz-grid-view names its data
}

export interface ExtJsFilter<ColKey extends string> {
  // We need an enum that has property (Ex: executedOn) but also property[min]/property[max] (Ex: executedOn[max])
  // because those are needed by the time range filter that has this kind of format in ext
  // TODO look into key of and mapped types for a better solution than any
  property: any;
  value: any;
}

export enum GridViews {
  ACTIONS_NEEDED = 'actionsNeeded-grid',
  IN_PROGRESS = 'inProgress-grid',
  EXECUTED = 'executed-grid',
  DISMISSED = 'dismissed-grid',
  ALL = 'all-grid',
}

export interface ManageAction {
  title: string;
  value: number;
  canBeDone: (item: ResponseGridItem) => boolean;
}

// Needed because some options also need the previous status
// Should conform with Status for easy usage
export enum InlineActionStatus {
  TO_BE_EXECUTED = 1,
  TO_BE_EXECUTED_FROM_PENDING = 10,
  TO_BE_EXECUTED_FROM_DISMISSED_AND_EXECUTED = 11,
  PENDING = 2,
  PENDING_FOR_RETRY = 20,
  IN_EXECUTION = 3,
  EXECUTION_SUCCESS = 4,
  EXECUTION_FAILED = 5,
  DISMISSED = 6,
  EXTERNAL_ACTION_NEEDED = 7,
  EXTERNAL_ACTION_NEEDED_FROM_DISMISSED_AND_EXECUTED = 70,
  DONE_EXTERNALLY = 8,
}

export enum XdrResponseErrorId {
  AUTHENTICATION_ERROR = 1,
  PERMISSION_ERROR = 2,
  ENDPOINT_NOT_FOUND = 900,
  PROTECTED_ENTITY_NOT_FOUND = 901,
  DOMAIN_NOT_FOUND = 902,
  RESPONSE_ACTIONS_DISABLED_FOR_SENSOR = 989,
  NO_DOMAIN = 993,
  DISABLED_SENSOR = 996,
  UNFETCHABLE_SENSOR = 997,
  UNKNOWN_ERROR = 999
}
